// extracted by mini-css-extract-plugin
module.exports = {"xstream_B":"B_xstream_B__5q3bX"};